import React from 'react';
import Box from '@mui/material/Box';
import DefaultLayout from 'layouts/DefaultLayout';
import Image from 'components/Image';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import makeClasses from 'hooks/useClasses';
import PropTypes from 'prop-types';
import styles from 'styles/jss/layouts/heroLayoutStyle';

const HeroLayout = ({
  children,
  heroImage,
  heroImageTitle,
  cta,
  heroStyle,
  heroCtaStyle
}) => {
  const classes = makeClasses(styles);
  return (
    <DefaultLayout>
      <Stack className={classes.pageLayout}>
        <Box
          xs={12}
          className={classes.hero}
          sx={{
            minHeight: '70vh',
            ...heroStyle
          }}
        >
          <Image
            src={heroImage}
            layout="fill"
            priority
            objectFit="cover"
            alt={heroImageTitle}
          />
          {cta && (
            <Box
              className={classes.heroCta}
              sx={heroCtaStyle}
            >
              <Box className="heroCtaContent" maxWidth="lg" padding={3}>
                {cta}
              </Box>
            </Box>
          )}
        </Box>
        <Grid container className={classes.body} maxWidth="lg" padding={3}>
          {children}
        </Grid>
      </Stack>
    </DefaultLayout>
  );
};

HeroLayout.defaultProps = {
  heroImageTitle: null,
  cta: null,
  heroStyle: {},
  heroCtaStyle: {}
};

HeroLayout.propTypes = {
  cta: PropTypes.node,
  heroImage: PropTypes.string.isRequired,
  heroImageTitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  heroStyle: PropTypes.shape(),
  heroCtaStyle: PropTypes.shape()
};

export default HeroLayout;
